import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { isAuthenticated } from '@/services/api/client-auth';

export default function ClientAuthGuard({ children }: { children: ReactNode }) {
  const location = useLocation();
  if (!isAuthenticated()) {
    return <Navigate to="/client/login" replace state={{ from: location.pathname }} />;
  }
  return <>{children}</>;
}
